export default "__VITE_ASSET__IWaWVRI___";